import React, { useEffect } from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay/hooks'
import { usePage, useAuth } from 'hooks'
import ReportsTable from './ReportsTable'
import { FlexColumn } from 'elements'
import CompanyDashboard from '../../dashboards/CompanyDashboard'

export default function ReportsTableContainer() {
  const { setHeader } = usePage()
  const { currentCompany } = useAuth()

  const data = useLazyLoadQuery(
    graphql`
      query ReportsTableContainerQuery($companyId: ID!) {
        companyById(id: $companyId) {
          ...ReportsTable_company
          ...CompanyDashboard_company
        }
      }
    `,
    { companyId: currentCompany.id },
    { fetchPolicy: 'network-only' },
  )

  useEffect(() => {
    setHeader({
      crumbs: [{ label: 'Reports', value: 'reports' }],
    })
  }, [setHeader])

  return (
    <FlexColumn>
      <CompanyDashboard company={data.companyById} />
      <ReportsTable company={data.companyById} />
    </FlexColumn>
  )
}
